<template>
  <div class="upload-csv-file" @mouseover="hover = true" @mouseleave="hover = false">
    <v-file-upload
      :model-value="modelValue"
      @update:model-value="onChange"
      filter-by-type="text/csv"
      :title="titleText"
      density="comfortable"
      hide-details
      icon="mdi-plus-circle-outline"
      class="add-file-input"
      :class="classNames"
      ref="fileInput"
      data-cy="fileInput"
    />
  </div>
</template>

<script lang="ts">
import { defineComponent, type PropType } from 'vue'

export default defineComponent({
  name: 'FileInput',
  emits: ['onFileChanged'],
  props: {
    modelValue: Object as PropType<File | null>
  },
  data() {
    return {
      hover: false
    }
  },
  computed: {
    titleText(): string {
      return this.hover
        ? 'registerMultipleDevices.selectFile'
        : 'registerMultipleDevices.browseFiles'
    },
    classNames(): string {
      return this.hover ? 'text-white' : 'text-primary'
    }
  },
  methods: {
    onChange(file: File[] | File | null): void {
      this.$emit('onFileChanged', Array.isArray(file) ? (file[0] ?? null) : file)
    }
  }
})
</script>

<style lang="scss" scoped>
.upload-csv-file {
  width: 100%;
  height: 100%;
  position: relative;

  :deep(.add-file-input) {
    position: absolute;
    width: 100%;
    height: 100%;

    .v-input__control {
      height: 100%;
    }

    .v-file-upload-dropzone.v-sheet {
      border: none;
      background-color: transparent;
      height: 100%;
      padding: 16px;
      color: currentColor;
    }

    .v-file-upload-icon {
      font-size: min(8vh, 80px);
      opacity: 1;

      .v-icon--size-default {
        font-size: 1em;
      }
    }

    .v-file-upload-title {
      color: currentColor;
      font-size: 1rem;
      text-transform: uppercase;
    }
  }
}
</style>
